<ion-content class="ion-padding">
  <app-autosave
    #autosave
    [hidden]="status !== ProcessStatus.WaitingInput"
    [isSaving]="autoSaving"
    [pendingChanges]="hasPendingChanges"
  ></app-autosave>

  <div class="max-page-width">
    <ion-item lines="none" mode="ios" class="title-with-back-button">
      <ion-button fill="clear" mode="ios" color="primary"
        (click)="goBack()" >
        <ion-icon class="bp-arrow-left" ></ion-icon>
      </ion-button>
      <ion-label class="ion-text-center ion-text-wrap">
        {{ getText( processConfig?.globalizationConfig, 'title' ) | uppercase }}
      </ion-label>
    </ion-item>

    <app-step-description
      [description]="getText( processConfig?.globalizationConfig, 'instructions' )"
    ></app-step-description>

    <ion-item lines="none" mode="ios" class="para-content">
      <ion-grid>
        <ion-row size="auto" >
          <ion-col size="6" >
            {{ 'selfEvaluation.reviewNotes' | translate }}
          </ion-col>
          <ion-col class="btns" size="6" >
            <ion-button color="primary" (click)="goToNotepad()" >
              {{ 'selfEvaluation.seeNotes' | translate }}
            </ion-button>
            <ng-container *ngIf="hasTwoPlusTwoCoaching && !hideTwoPlusTwoButton" >
              <ion-button color="secondary" (click)="goToCoaching()" >
                {{ 'selfEvaluation.seeCoaching' | translate }}
              </ion-button>
            </ng-container>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>

    <ion-item lines="none" mode="ios" class="para-content form" >
      <form [formGroup]="formGroup" *ngIf="formGroup" >
        <div *ngFor="let group of processConfig.questionsGroups | questionGroupAttributes: user?.attributes; let groupIndex = index">
          <ng-container *ngIf="(group.hasCalculateQuestions && !questionsType[QuestionType.Calculate].hidden) ||  !group.hasCalculateQuestions">
            <h4 >
              {{ !hideQuestionNumber ? (groupIndex + 1) + ' - ' + getText( group.globalizationConfig, 'title' ) : getText( group.globalizationConfig, 'title' ) }}
            </h4>
          </ng-container>
          <app-question-types
            *ngFor="let question of group.questions"
            [question]="question"
            [formGroup]="formGroup"
          ></app-question-types>
        </div>
      </form>
    </ion-item>

    <ng-container *ngIf="status === ProcessStatus.WaitingInput" >
      <div class="bottom-buttons" text-right>
        <ion-button mode="ios" color="primary" class="save"
          [disabled]="autoSaving"
          (click)="save(formGroup, true)" >
          {{ 'generic.save' | translate }}
        </ion-button>
        <ion-button mode="ios" color="secondary" class="save"
          (click)="send(formGroup)" >
          {{ 'generic.sendEvaluation' | translate }}
        </ion-button>
      </div>
    </ng-container>
  </div>
</ion-content>